import { render, staticRenderFns } from "./TourSummary.vue?vue&type=template&id=ece696b8&scoped=true&"
import script from "./TourSummary.vue?vue&type=script&lang=js&"
export * from "./TourSummary.vue?vue&type=script&lang=js&"
import style0 from "./TourSummary.vue?vue&type=style&index=0&id=ece696b8&prod&lang=scss&scoped=true&"
import style1 from "./TourSummary.vue?vue&type=style&index=1&id=ece696b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece696b8",
  null
  
)

export default component.exports